/* eslint-disable max-lines */
import { useCallback, useEffect, useState } from 'react';

import { useChatApi } from '../api/useChatApi';
import { useChatContext } from '../context/ChatProvider/hooks/useChatContext';

import { useQuestion } from './useQuestion';

export const useChat = () => {
  const [generatingAnswer, setGeneratingAnswer] = useState(false);

  const {
    history, setHistory,
    chatStatus, setChatStatus,
    chatId, publish,
  } = useChatContext();
  const { createChat, getHistory } = useChatApi();

  const { addQuestion: addQuestionAPI } = useQuestion();

  const fetchHistory = useCallback(async () => {
    const chatHistory = await getHistory(chatId);

    chatHistory.forEach((message) => {
      if (message.done) {
        setChatStatus('done');
      }
    });

    if (chatHistory.length > 0) {
      setHistory(chatHistory);
    }
  }, [chatId, setHistory, getHistory, setChatStatus]);

  // Automatically fetch history when component is mounted
  useEffect(fetchHistory, [fetchHistory]);

  const addQuestion = async (question, callback) => {
    try {
      setGeneratingAnswer(true);

      let currentChatId = chatId;

      // if chatId is not set, create a new chat. Chat name is from the first question
      if (currentChatId === undefined) {
        const chatName = question.split(' ').slice(0, 3).join(' ');
        const chat = await createChat(chatName);
        currentChatId = chat.chat_id;
      }

      const chatQuestion = {
        model: null,
        question,
        temperature: null,
        max_tokens: null,
      };

      await addQuestionAPI(currentChatId, chatQuestion);

      callback?.();
    } catch (error) {
      if (error.response?.status === 429) {
        publish({
          variant: 'danger',
          text: 'You have reached the limit of requests, please try again later',
        });

        return;
      }

      publish({
        variant: 'danger',
        text: 'Error occurred while getting answer',
      });
    } finally {
      setGeneratingAnswer(false);
    }
  };

  return {
    history,
    addQuestion,
    generatingAnswer,
    chatId,
    publish,
    chatStatus,
    setChatStatus,
    fetchHistory,
  };
};

export default useChat;
